import { render, staticRenderFns } from "./CenterIconMessage.vue?vue&type=template&id=276a5cc8&scoped=true"
import script from "./CenterIconMessage.vue?vue&type=script&lang=js"
export * from "./CenterIconMessage.vue?vue&type=script&lang=js"
import style0 from "./CenterIconMessage.vue?vue&type=style&index=0&id=276a5cc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276a5cc8",
  null
  
)

export default component.exports